module.exports = __webpack_public_path__ + "img/e43d928.jpg";